export default __webpack_public_path__ + "static/media/img_one.43a78cd2.png";